import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { safeLocalStorage } from '@common/safe-storage';


@Component({
  selector: 'app-clear',
  template: ``,
})
export class ClearComponent {

  router = inject(Router);

  constructor() {
    safeLocalStorage.clear();
    this.router.navigate(['/']);
  }
}
